
<template>
  <div>
    <div class="container-fluid px-4">
      <div class="row">
        <tab-group
          v-if="tabsLists.includes($route.name) === true"
          :routes="routes"
        ></tab-group>
        <div class="col-12 pl-0">
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {permissionMixin} from "@/mixins/permissionMixins";
import TabGroup from "@/components/common/TabGroup.vue";
import {mapMutations} from 'vuex'

export default {
  name: "VesselAudit",
  mixins : [permissionMixin],
  data() {
    return {
      tabsLists : [
        'VesselAuditDue',
        'VesselList',
        'ObjectiveEvidenceList',
      ],
      newAppointmentAuditDuePage: [
        'VesselAuditDue',
        'VesselAuditRecordList',
        'AppointmentDetails',
      ],
    }
  },
  created(){
    window.addEventListener('storage', this.handleNewAppointmentAuditDueLocalStorage)
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.handleNewAppointmentAuditDueLocalStorage)
  },
  methods: {
    handleNewAppointmentAuditDueLocalStorage(event) {
      if (event.key === 'newAppointmentAuditDue' && this.newAppointmentAuditDuePage.includes(this.$route.name)) {
        if(this.$route.name === 'AppointmentDetails'){
          window.location.reload()
        }

        const newAppointment = JSON.parse(localStorage.getItem('newAppointmentAuditDue'))
        this.SET_NEW_APPOINTMENT_AUDIT_DUE_REFS(newAppointment)
      }
    },
    ...mapMutations([
      'SET_NEW_APPOINTMENT_AUDIT_DUE_REFS'
    ]),
  },
  components: {TabGroup},
  computed : {
    routes() {
      let routes = [];

      if (this.isAllowed('vessel-ia.appointments.vessel-audit-due.menu') === true) {
        routes.push(
          {
            name : 'VesselAuditDue',
            text : 'Vessel Audit Due'
          });
      }

      if (this.user.is_vessel === true && this.isAllowed('vessel-ia.appointments.audit-records.menu') === true) {
        routes.push(
          {
            name : 'VesselAuditRecordList',
            text : 'Vessel Audit Records',
            params : {
              vessel_id : this.user?.vessel_id
            }
          });
      } else {
        routes.push(
          {
            name : 'VesselList',
            text : 'Vessel Audit Records'
          });
      }

      if (this.user.is_vessel === false && this.isAllowed('vessel-ia.appointments.objective-evidence.menu') === true) {
        routes.push(
          {
            name : 'ObjectiveEvidenceList',
            text : 'Vessel Objective Evidence'
          });
      }



      return routes;
    }
  }
}
</script>



